<template>
    <v-card>
        <v-toolbar flat color="purple" dark>
            <v-toolbar-title>{{ trans('document-checklist.title') }}</v-toolbar-title>
            <v-text-field v-model="search" dense clearable prepend-icon="search" :label="trans('common.search')"
                class="ml-2" style="margin-bottom:-15px" />
            <v-spacer></v-spacer>
            <v-select v-model="groupBy" dense :label="trans('document-checklist.group-by')" :items="groupByItems"
                style="margin-bottom:-15px;width:30px;" prepend-icon="compress" clearable />
            <template v-if="!disabled">
                <v-spacer></v-spacer>
                <v-btn icon @click="edit" color="white"><v-icon>edit</v-icon></v-btn>
            </template>
        </v-toolbar>

        <v-data-table v-bind="{
            items: documentLists,
            loading: isLoading,
            headers,
            disablePagination: true,
            hideDefaultFooter: true,
            itemClass: (item) => item.done ? 'green lighten-5' : '',
            showGroupBy: false,
            
        }" :search.sync="search" :group-by.sync="groupBy">
            >
            <template v-slot:group.header="slot">
                <td :colspan="headers.length - 2">
                    <strong>{{ headers.find(e => e.value == slot.groupBy[0])?.text }}:</strong>
                    <template v-if="slot.groupBy[0] === 'done'">
                        <v-icon v-if="slot.group" color="success">task_alt</v-icon>
                        <v-icon v-else color="grey">radio_button_unchecked</v-icon>
                    </template>
                    <template v-else>
                        {{ slot.group || '-' }}
                    </template>
                </td>
                <td>
                    <v-btn icon @click="slot.toggle"><v-icon>{{ slot.isOpen ? 'unfold_more' : 'unfold_less'
                    }}</v-icon></v-btn>
                    <!-- <v-btn icon @click="slot.remove"><v-icon>close</v-icon></v-btn> -->
                </td>
            </template>

            <!--
            <template v-slot:header.done="{ header }">
                {{ header.text }}
                <v-btn icon small color="primary" @click="groupBy = header.value"><v-icon>compress</v-icon></v-btn>
            </template>
            <template v-slot:header.category="{ header }">
                {{ header.text }}
                <v-btn icon small color="primary" @click="groupBy = header.value"><v-icon>compress</v-icon></v-btn>
            </template>
            -->
            <template v-slot:item.done="{ item }">
                <v-icon v-if="item.done" color="success" dense>task_alt</v-icon>
                <v-icon v-else color="grey" dense>radio_button_unchecked</v-icon>
            </template>
            <template v-slot:item.is_private="{ item }">
                <v-icon v-if="item.is_private" color="warning">visibility_off</v-icon>
                <v-icon v-else color="grey">visibility</v-icon>
            </template>
            <template v-slot:item.title="{ item }">
                <a v-if="item.done" :href="item.url" target="_blank">{{ item.title }}</a>
                <template v-else>{{ item.title }}</template>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn v-if="!item.done" icon color="primary"
                    @click="uploadItem(item)"><v-icon>cloud_upload</v-icon></v-btn>
                <v-btn v-else icon color="primary" :href="item.url" target="_blank"><v-icon>download</v-icon></v-btn>
            </template>
        </v-data-table>
        <!--- editor popup -->
        <v-dialog persistent scrollable v-if="editing" v-model="editing">
            <DocumentChecklistEditor v-model="documentLists" v-bind="{
                projectId,
            }" @close="editing = false" @submitted="onSaved" />
        </v-dialog>
        <!--- uploader popup -->
        <v-dialog persistent scrollable v-if="uploadTarget" v-model="uploadTarget" max-width="600">
            <DocumentChecklistUploader v-bind="{
                projectId,
                value: uploadTarget,
            }" @close="uploadTarget = null" @submit="uploadTarget = null; refreshData()" />
        </v-dialog>
    </v-card>
</template>
<script>
import DocumentChecklistEditor from './DocumentChecklistEditor.vue';
import DocumentChecklistUploader from './DocumentChecklistUploader.vue';
import { NormalizeDocumentList } from './ProjectUtils';


export default {
    props: {
        value: { type: Object, required: true, },///<<< Project object
        disabled: { type: Boolean, default: false, },
        loading: { type: Boolean, default: false, },
    },
    data() {

        const headers = [
            {
                value: 'done',
                sortable: true,
                width: 100,
            },
            {
                value: 'title',
                sortable: true,
                groupable: false,
            },
            {
                value: 'category',
                sortable: true,
            },
            {
                value: 'is_private',
                sortable: true,
            },
            {
                value: 'actions',
                text: "Azioni",
                sortable: false,
                groupable: false,
            },
        ].map(e => Object.assign({ text: trans('document-checklist.fields.' + e.value) }, e));



        let groupByItems = ['category', 'done'].map((k) => {
            return {
                text: this.trans(`document-checklist.fields.${k}`),
                value: k,
            };
        });

        return {
            headers,

            search: '',

            editing: false,
            groupBy: null,
            groupByItems,

            uploadTarget: null,

            fetching: false,
            error: null,
        }
    },
    computed: {
        documentLists() {
            return this.value.document_lists;
        },
        projectId() {
            return this.value.id;
        },
        isLoading() {
            return this.loading || this.fetching;
        },
    },
    methods: {
        edit() {
            this.editing = true;
        },
        uploadItem(item) {
            this.uploadTarget = item;
        },
        async refreshData() {
            this.fetching = true;
            try {
                let r = await axios.get(`/projects/${this.projectId}/document-list`);

                if (!r?.data?.data) {
                    throw new Error('Unexpected response');
                }
                console.log(r.data.data);
                this.value.document_lists = r.data.data.map(e => NormalizeDocumentList(e));


            } catch (e) {

            } finally {
                this.fetching = false;
            }
        },
        onSaved(data) {
            this.value.document_lists = data;
        }
    },
    components: {
        DocumentChecklistEditor,
        DocumentChecklistUploader,
    },
}
</script>